<template>
    <h5 class="mb-4 font-semibold text-gray-600 dark:text-gray-300">
        Descriptive labels for options
    </h5>
    <div v-for="(answer, answerValue) in answersArray"
         :key="'answer-' + answerValue"
         class="mb-4">
        <div class="block text-sm mb-1">
            <div class="relative">
                <div
                    class="absolute inset-y-0 left-0 px-3 flex items-center justify-center text-sm font-medium leading-5 text-gray-700 border-r border-gray-300 dark:border-gray-600 dark:text-gray-300 rounded-l-md"
                    :style="{ color: answer.textColor }"
                >
                    {{ answerValue }}
                </div>
                <input v-model="answer.label"
                       type="text"
                       :placeholder="answerLabelExamples[answerValue]"
                       class="pl-10 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:shadow-outline-white dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                       :style="{ color: answer.textColor, backgroundColor: answer.bgColor }"
                >
            </div>
            <jet-input-error :message="errors?.[answerValue]?.label"></jet-input-error>
        </div>
        <div class="colors grid xl:grid-cols-2 gap-3 pl-10">
            <label class="flex flex-wrap items-center text-sm">
                <span class="text-gray-700 dark:text-gray-400 block w-full mb-1">Background color:</span>
                <input :value="answer.bgColor || '#000000'" type="color"
                       @input.prevent.stop="answer.bgColor = $event.target.value"
                       class="block py-0 px-1 dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:shadow-outline-white dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                <input type="text" v-model.trim="answer.bgColor"
                       class="block py-0 px-1 ml-2 w-1/2 dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:shadow-outline-white dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                <jet-button
                    :bg-dark="true"
                    class="ml-2 px-2"
                    @click.prevent="answer.bgColor = null"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="white">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </jet-button>
                <jet-input-error :message="errors?.[answerValue]?.bgColor"></jet-input-error>
            </label>
            <label class="flex flex-wrap items-center text-sm">
                <span class="text-gray-700 dark:text-gray-400 block w-full mb-1">Text color:</span>
                <input :value="answer.textColor || '#000000'"
                       @input.prevent.stop="answer.textColor = $event.target.value"
                       type="color"
                       class="block py-0 px-1 dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:shadow-outline-white dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                <input type="text" v-model.trim="answer.textColor"
                       class="block py-0 px-1 ml-2 w-1/2 dark:border-gray-600 dark:bg-gray-700 focus:outline-none focus:shadow-outline-white dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                <jet-button
                    :bg-dark="true"
                    class="ml-2 px-2"
                    @click.prevent="answer.textColor = null"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="white">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </jet-button>
                <jet-input-error :message="errors?.[answerValue]?.textColor"></jet-input-error>
            </label>
        </div>
    </div>
</template>

<script>
import {useModelWrapper} from "@/composables/modelWrapper";
import JetButton from "@/Jetstream/Button";
import JetInputError from "@/Jetstream/InputError";

export default {
    name: "SurveyQuestionType1AnswerEditor",
    components: {
        JetInputError,
        JetButton,
    },
    props: {
        answers: {
            type: Object,
            default: {}
        },
        errors: {
            type: Object,
        }
    },
    setup(props, {emit}) {
        const answerLabelExamples = {
            1: 'eg: Very low',
            2: 'eg: Low',
            3: 'eg: Medium',
            4: 'eg: High',
            5: 'eg: Very high',
        };

        const answersArray = useModelWrapper(props, emit, 'answers')

        return {
            answerLabelExamples,
            answersArray,
        };
    },
}
</script>

<style scoped>

</style>
